import React, { useEffect, useState } from "react";
import Modal from "react-awesome-modal";
import { Link } from "react-router-dom";
import useDelete from "../../Hooks/useDelete";
import useUpdate from "../../Hooks/useUpdate";
import useValidateRole from "../../Hooks/useValidateRole";
import Table from "./../../Components/Table";
import Api from "../../Hooks/Api";
import Upload from "../../Hooks/Upload";
import "./application.css";
import swal from "sweetalert";
const AllApplications = () => {
  const [open, setOpen] = useState(false);
  const [inputs, setInputs] = useState({});
  const [view, setView] = useState(false);

  const [update, setUpdate] = useState(false);
  const [activeTab, setActiveTab] = useState("Applications");
  const [PageRole] = useState("Applications");

  const [RowData, setRowData] = useState([]);

  const [inputsDocuments, setInputsDocuments] = useState({});

  const url = "api/applicants";

  const [selectedFile, setselectedFile] = useState("");
  const [loaded, setloaded] = useState("");
  const [message, setmessage] = useState("");
  const [applicationTypeOptions, setApplicationType] = useState([
    { name: "Approved" },
    { name: "Rejected" },
    { name: "Deferred" },
  ]);
  const maxSelectFile = (event) => {
    let files = event.target.files; // create file object
    if (files.length > 1) {
      const msg = "Only One file can be uploaded at a time";
      event.target.value = null;
      setmessage(msg);

      return false;
    }
    return true;
  };
  const onChangeHandler = (event, name) => {
    //for multiple files
    var files = event.target.files;
    if (maxSelectFile(event)) {
      setselectedFile(files);
      setloaded(0);
      onClickHandler(event, name, files);
    }
  };
  const onClickHandler = (event, name, selectedFile) => {
    event.preventDefault();
    if (selectedFile) {
      const data = new FormData();
      for (var x = 0; x < selectedFile.length; x++) {
        data.append("file", selectedFile[x]);
      }
      Upload.post("/api/upload/files", data, {
        onUploadProgress: (ProgressEvent) => {
          setloaded((ProgressEvent.loaded / ProgressEvent.total) * 100);
        },
      })
        .then((res) => {
          if (res.status == "200" && res.data.resultCode == "00") {
            setmessage("Uploaded successfully");
            setInputsDocuments((inputs) => ({
              ...inputs,
              [name]: res.data.data,
            }));
          } else {
            setmessage("upload fail");
          }
        })
        .catch((err) => {
          setmessage("upload fail");
        });
    } else {
      setmessage("Select a file to upload");
    }
  };

  const fetchDocuments = async (applicationId) => {
    try {
      Api.get(
        "api/applicationsDocuments/getByApplicationId?applicationId=" +
          applicationId,
      )
        .then(function (response) {
          if (response.status === 200) {
            setInputsDocuments(response.data);
            setInputsDocuments((inputsDocuments) => ({
              ...inputsDocuments,
              ["applicationId"]: applicationId,
            }));
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };

  const MoreActions = (props) => {
    return (
      <span>
        <a
          class="btn btn-success btn-sm dropdown-toggle"
          href="#"
          role="button"
          id="dropdownMenuLink"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          More Actions&nbsp;&nbsp;
          <i class="fa fa-caret-down" aria-hidden="true"></i>
        </a>

        <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
          <a
            style={{ cursor: "pointer" }}
            class="dropdown-item "
            onClick={(e) => handleView(props.selecteditem, e)}
          >
            View
          </a>
        </div>
      </span>
    );
  };
  const setApplicationsdata = async (data) => {
    const rows = data?.applications || [];

    rows.forEach((k) => {
      const Rowdata = {
        id: k.id,
        refNo: k.id,
        location: k.location,
        profile:
          "Number of Kenyan Employees: " +
          k.kenyanEmployees +
          " number of Expatriates " +
          k.numberOfExpatriates,
        createdAt: new Date(k.applicant.dob).toLocaleDateString("en-GB"),
        fullName: k.applicant.fullName,
        applicationType: k.applicationType,
        permitType: k.permitType,
        country: k.applicant.country.name,
        telNo: k.applicant.telNo,
        email: k.applicant.email,
        passportNumber: k.applicant.passportNumber,
        status: k.status,
        role: k.role?.name,
        establishment: k.user?.name,
        dob: new Date(k.applicant.dob).toLocaleDateString("en-GB"),
        Actions: <MoreActions selecteditem={k} />,
      };
      setRowData((inputs) => [...inputs, Rowdata]);
    });
  };
  const FetchAll = async () => {
    setRowData([]);
    try {
      Api.get("api/applications/getAll?page=0&size=10")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setApplicationsdata(data);
            const totalPages = data.totalPages;
            for (let i = 0; i < totalPages; i++) {
              let nextPage = parseFloat(i) + parseFloat(1);
              Api.get("api/applications/getAll?page=" + nextPage + "&size=10")
                .then(function (response) {
                  if (response.status === 200) {
                    const data = response.data;
                    setApplicationsdata(data);
                  }
                })
                .catch(function (error) {})
                .then(function () {
                  // always executed
                });
            }
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  useEffect(() => {
    FetchAll();
  }, []);

  const handleView = (k) => {
    setInputs(k.applicant);
    setInputsDocuments((inputsDocuments) => ({
      ...inputsDocuments,
      ["applicationId"]: k.id,
    }));
    setInputs((inputs) => ({ ...inputs, ["role"]: k.role }));
    setInputs((inputs) => ({
      ...inputs,
      ["applicationType"]: k.applicationType,
    }));
    setInputs((inputs) => ({ ...inputs, ["role"]: k.role }));
    setInputs((inputs) => ({
      ...inputs,
      ["permitType"]: k.permitType,
    }));
    setInputs((inputs) => ({
      ...inputs,
      ["permitType"]: k.permitType,
    }));

    if (k.id) {
      fetchDocuments(k.id);

      setView(true);
      setOpen(true);
    } else {
      alert("Select a record to view");
    }
  };
  const handleCloseModal = () => {
    setInputs({});
    setOpen(false);
    setView(false);
    setUpdate(false);
  };

  const HandleUpdate = (inputs, url) => {
    useUpdate(url, inputs);
    setTimeout(function () {
      FetchAll();
    }, 4000);
  };

  const handleSubmitDocuments = (event) => {
    event.preventDefault();
    if (
      !inputsDocuments.applicationId ||
      inputsDocuments.applicationId == "undefined"
    ) {
      alert("Add or select Applicant first");
      return;
    }
    let body = {
      remarks: inputsDocuments.remarks,
      status: inputsDocuments.status,
      applicationId: inputsDocuments.applicationId,
      stage: "Documents",
    };
    HandleSave(body, "api/applications/approval", "approval");
  };

  const handleDocumentsInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputsDocuments((documents) => ({ ...documents, [name]: value }));
  };
  const useSave = (url = ``, inputs = {}, menu = ``, config = {}) => {
    let data;
    let headers;
    if (inputs instanceof FormData) {
      data = inputs;
      headers = { ...config.headers }; // Don't set Content-Type header, let the browser set it
    } else {
      data = JSON.stringify(inputs);
      headers = { "Content-Type": "application/json", ...config.headers };
    }
    Api.post(url, data, { headers })
      .then((response) => {
        if (response.data.resultCode === "00") {
          if (menu === "Applications") {
            var result = JSON.parse(response.data.data);

            setInputsDocuments((inputsDocuments) => ({
              ...inputsDocuments,
              ["applicationId"]: result.id,
            }));
          }

          swal("", "saved", "success");
        } else {
          swal("", response.data.description, "error");
        }
      })
      .catch((error) => {
        swal("", "Failed", "error");
      });
  };
  const HandleSave = (inputs, url, menu) => {
    useSave(url, inputs, menu);
    setTimeout(function () {
      FetchAll();
    }, 4000);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (update) {
      HandleUpdate(inputs, url);
    } else {
      HandleSave(inputs, url, "Applications");
    }
  };
  const CallDeleteHook = (id) => {
    useDelete(url + "/delete?id=" + id);
    setTimeout(function () {
      FetchAll();
    }, 4000);
  };
  const HandleDelete = (k) => {
    if (k.id) {
      CallDeleteHook(k.id);
    } else {
      alert("Select a record to delete");
    }
  };

  const columns = [
    { label: "Ref. No", field: "refNo", sort: "asc" },
    { label: "Establishment", field: "establishment", sort: "asc" },
    { label: "Name", field: "fullName", sort: "asc" },
    { label: "Role", field: "role", sort: "asc" },
    { label: "Profile", field: "profile", sort: "asc" },
    { label: "Location", field: "location", sort: "asc" },
    { label: "Passport Number", field: "passportNumber", sort: "asc" },
    { label: "Application Type", field: "applicationType", sort: "asc" },
    { label: "Permit Type", field: "permitType", sort: "asc" },
    { label: "Country", field: "country", sort: "asc" },
    { label: "Tel No", field: "telNo", sort: "asc" },
    { label: "Status", field: "status", sort: "asc" },
    { label: "Application Date", field: "createdAt", sort: "asc" },
    { label: "Actions", field: "Actions", sort: "asc" },
  ];

  const ActionsBtn = () => (
    <div>
      <button
        className="btn btn-warning p-2"
        type="button"
        onClick={handleCloseModal}
      >
        Close
      </button>
    </div>
  );

  return (
    <div id="content" className="content">
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item">
          <Link to="/">Home</Link>
        </li>
        <li className="breadcrumb-item active">All Applications </li>
      </ol>
      <h1 className="page-header mb-3">All Application</h1>
      <div style={{ backgroundColor: "white" }}>
        <div className="row">
          <div className="col-sm-12">
            <Table Rows={RowData} columns={columns} />
          </div>
        </div>
      </div>

      <Modal visible={open} width="80%" height="80%" effect="fadeInUp">
        <div style={{ overflowY: "auto", height: "100%" }}>
          <a
            style={{ "pointer-events": "none" }}
            className="close"
            onClick={(e) => {
              e.preventDefault();
              handleCloseModal();
            }}
          >
            &times;
          </a>
          <div className="container-fluid">
            <div className="col-sm-12">
              <div className="ibox-content">
                <br />

                <div>
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a
                        className={`nav-link ${activeTab === "Applications" ? "active" : ""}`}
                        id="Applications-tab"
                        onClick={() => setActiveTab("Applications")}
                        role="tab"
                        aria-selected={activeTab === "Applications"}
                      >
                        Applications
                      </a>
                    </li>
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a
                        className={`nav-link ${activeTab === "dependants" ? "active" : ""}`}
                        id="dependants-tab"
                        onClick={() => setActiveTab("dependants")}
                        role="tab"
                        aria-selected={activeTab === "dependants"}
                      >
                        Documents
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content" id="myTabContent">
                    <div
                      className={`tab-pane fade ${activeTab === "Applications" ? "show active" : ""}`}
                      id="Applications-tab-pane"
                      role="tabpanel"
                      aria-labelledby="Applications-tab"
                    >
                      <div>
                        <h3>Applications</h3>
                        <table className="table table-sm">
                          <tbody>
                            <tr>
                              <td className="font-weight-bold">
                                Establishment:
                              </td>
                              <td>{inputs.user?.name}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">Role:</td>
                              <td>{inputs.role?.name}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">Name:</td>
                              <td>{inputs.fullName}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">
                                Application Type:
                              </td>
                              <td>{inputs.applicationType}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">permit Type:</td>
                              <td>{inputs.permitType}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">
                                Passport Number:
                              </td>
                              <td>{inputs.passportNumber}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">Tel No:</td>
                              <td>{inputs.telNo}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">Email:</td>
                              <td>{inputs.email}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">Gender:</td>
                              <td>{inputs.gender?.name}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">Country:</td>
                              <td>{inputs.country?.name}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">
                                Places Of Birth:
                              </td>
                              <td>{inputs.placesOfBirth}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">
                                Physical Address:
                              </td>
                              <td>{inputs.physicalAddress}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">DOB:</td>
                              <td>
                                {" "}
                                {new Date(inputs.dob).toLocaleDateString(
                                  "en-GB",
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div
                      className={`tab-pane fade ${activeTab === "dependants" ? "show active" : ""}`}
                      id="areas-tab-pane"
                      role="tabpanel"
                      aria-labelledby="dependants-tab"
                    >
                      <form
                        className="form-horizontal"
                        onSubmit={handleSubmitDocuments}
                      >
                        <div className="document-list">
                          {[
                            {
                              label: "Copy of completed application form 25",
                              key: "form_25",
                            },
                            {
                              label:
                                "Letter explaining purpose of entry addressed to PS, Ministry of Tourism",
                              key: "letter_explaining_purpose",
                            },
                            {
                              label: "Copy of valid passport of Applicant",
                              key: "passport_copy",
                            },
                            ...(inputs.applicationType === "Renewal"
                              ? [
                                  {
                                    label:
                                      "Copy of current entry permit (Renewal only)",
                                    key: "current_permit",
                                  },
                                ]
                              : []),
                            {
                              label: "Copy of Tourism license for the company",
                              key: "tourism_license",
                            },
                            ...(inputs.applicationType === "New application"
                              ? [
                                  {
                                    label:
                                      "Certificate of incorporation of the company",
                                    key: "certificate_of_incorporation",
                                  },
                                  {
                                    label:
                                      "Memorandum & Articles of Association of the company",
                                    key: "memorandum",
                                  },
                                ]
                              : []),
                            {
                              label: "Copy of CR-12",
                              key: "cr12",
                            },
                            {
                              label: "Company/Applicant PIN",
                              key: "pin",
                            },
                            ...(inputs.applicationType === "Renewal"
                              ? [
                                  {
                                    label:
                                      "Valid KRA Tax Compliance Certificate (Renewals)",
                                    key: "tax_compliance",
                                  },
                                ]
                              : []),
                            {
                              label:
                                "Valid Tourism Fund Clearance (for levy payers and renewals)",
                              key: "tourism_fund_clearance",
                            },
                            ...(inputs.applicationType === "Renewal"
                              ? [
                                  {
                                    label:
                                      "Audited accounts for the company (Renewals only)",
                                    key: "audited_account",
                                  },
                                ]
                              : []),

                            ...(inputs.permitType ===
                            "Entry permit class G (Investor)"
                              ? [
                                  {
                                    label:
                                      "Proof of capital investment (USD 100,000)",
                                    key: "proof_of_capital",
                                  },
                                ]
                              : []),

                            ...(inputs.applicationType === "Renewal" ||
                            inputs.permitType !==
                              "Entry permit class G (Investor)"
                              ? [
                                  {
                                    label: `Employee profile ${
                                      inputs.permitType ===
                                      "Entry permit class G (Investor)"
                                        ? "(Details of all employees in the company - citizens and non-citizens; ID & passport numbers)"
                                        : ""
                                    }`,
                                    key: "employee_profile",
                                  },
                                ]
                              : []),
                            ...(inputs.permitType ===
                            "Entry permit class D (Employed)"
                              ? [
                                  {
                                    label:
                                      "Contract offer of employment authored by the employer",
                                    key: "employee_contract",
                                  },
                                  {
                                    label:
                                      "Comprehensive CV and testimonials translated into English",
                                    key: "employee_cv",
                                  },
                                  {
                                    label:
                                      "Proof of an understudy with certificates, CV, ID copy and contract",
                                    key: "employee_certificates",
                                  },
                                  {
                                    label:
                                      "Notarized copies of academic qualifications and/or proof of specialized skills",
                                    key: "employee_notorzed_docs",
                                  },
                                ]
                              : []),
                            ...(inputs.permitType ===
                            "Entry permit special pass"
                              ? [
                                  {
                                    label:
                                      "Valid Tourism Fund Clearance for the company",
                                    key: "tourism_fund_cert",
                                  },
                                ]
                              : []),
                          ].map((doc, index) => (
                            <div className="document-row" key={doc.key}>
                              <div className="document-number">
                                {index + 1}.
                              </div>

                              <div className="document-label">{doc.label}</div>

                              <div className="document-view">
                                {inputsDocuments[doc.key] ? (
                                  <a
                                    href={
                                      process.env.REACT_APP_BASE_URL +
                                      "api/upload/files/" +
                                      inputsDocuments[doc.key]
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                    className="btn btn-sm btn-primary"
                                  >
                                    View
                                  </a>
                                ) : (
                                  <span className="text-muted">No file</span>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                        <p>
                          Comments
                          {inputsDocuments.comments}
                        </p>
                      </form>
                    </div>
                  </div>
                  <br />
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <ActionsBtn />
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AllApplications;
